import {addWeeks, format, startOfWeek} from 'date-fns';
import NextLink from 'next/link';

import {Button, Card, Icon, RadialProgress, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {CheckInCardActiveMember} from '../CTACard';

import {CheckInCardProps} from './CheckInCard.types';

import * as css from './CheckInCard.css';

export const CheckInCard = ({
  canCheckIn = false,
  completedCheckIns = 0,
  hasSelectedActionPlan = false,
  totalCheckIns = 1,
  columnSpan = [8, 4],
}: CheckInCardProps) => {
  const totalCheckInCount = totalCheckIns || 0;

  return hasSelectedActionPlan ? (
    <NextLink href="/checkin" passHref>
      <Card
        as="a"
        className={sprinkles({
          content: 'between',
          dir: 'col',
          flex: 'flex',
          gap: 24,
          gridColumnSpan: columnSpan,
          overflow: 'hidden',
        })}
        variant="white">
        <div className={sprinkles({flex: 'flex', gap: 16})}>
          <div className={sprinkles({dir: 'col', flex: 'flex', gap: 24})}>
            <Text
              className={sprinkles({flex: 'flex', gap: 12, items: 'center'})}
              color="deepBurgundy"
              variant="heading3">
              <Icon color="eggplantDark" name="CircleWavyCheck" size={40} weight="light" />
              {canCheckIn ? 'Check-ins' : 'Checked-in'}
            </Text>

            <Text
              as="p"
              className={sprinkles({dir: 'col', flex: 'flex', gap: 24})}
              color="mineShaft">
              <span>{`Out of ${totalCheckInCount} total check-ins, you’ve checked in ${completedCheckIns} times.`}</span>
            </Text>
          </div>

          <RadialProgress
            className={css.progress}
            label={
              <span className={sprinkles({flex: 'flex', items: 'end'})}>
                <Text fontWeight="light" variant="heading1">
                  {completedCheckIns}
                </Text>
                <Text fontWeight="light" variant="heading3">{`/${totalCheckInCount}`}</Text>
              </span>
            }
            maxValue={totalCheckInCount}
            stroke={3}
            value={completedCheckIns}
            style={{width: 150}}
          />
        </div>
        <div>
          {
            <Button
              as="button"
              variant="primary"
              icon={canCheckIn ? 'ArrowRight' : 'Check'}
              disabled={!canCheckIn}>
              {canCheckIn ? 'Check-in' : 'You checked-in this week'}
            </Button>
          }
        </div>

        <div className={css.dateContainer}>
          <Text
            as="p"
            className={sprinkles({dir: 'col', flex: 'flex', gap: 12})}
            color="deepBurgundy"
            textAlign="center">
            Your next check-in is
            <Text color="inherit" variant="bodyXLarge">
              {format(startOfWeek(addWeeks(new Date(), 1), {weekStartsOn: 1}), 'EEEE, MMM d')}
            </Text>
          </Text>
        </div>
      </Card>
    </NextLink>
  ) : (
    <CheckInCardActiveMember />
  );
};
